import { Navbar } from "../shared/components/Navbar.js";
import { ApiService } from "../shared/services/ApiService.js";
import { AuthService } from "../shared/services/AuthService.js";
import { AppConfig } from "../shared/config/AppConfig.js";
import { TemplateEngine } from "../shared/utils/TemplateEngine.js";
import vehiclesTemplate from "./templates/vehicles.html?raw";
import addVehicleModalTemplate from "./templates/add-vehicle-modal.html?raw";
import Swal from "sweetalert2";
import { ImageProcessor } from "../shared/utils/ImageProcessor.js";
import { DocumentViewer } from "../profile/documentViewer.js";

import { VehicleSelectModule } from "../shared/components/VehicleSelectModule.js";


// Swiper core
import Swiper from 'swiper';

// módulos específicos
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

export const VehiclesController = {
	render: async () => {
		try {
			const user = AuthService.getCurrentUser();
			const respVehi = await ApiService.post("apiapp/ObtenerVehiculos", null, user?.token);
			const maxVehicles =
				user?.userType === "company" ? AppConfig.limits.maxVehiclesCompany : AppConfig.limits.maxVehiclesPerson;

			const vehicles = respVehi.vehiculos || [];
			const formattedVehicles = vehicles.map((vehicle) => ({
				...vehicle,
				kilometers: vehicle.Kilometraje.toLocaleString(),
				fechaAdquisicion: vehicle.FechaAdquisicion || null,
				fechaAdquisicionFormatted: vehicle.FechaAdquisicion
					? new Date(vehicle.FechaAdquisicion + 'T12:00:00').toLocaleDateString('es-AR', { year: 'numeric', month: 'long' })
					: "",
			}));

			const data = {
				vehicles: formattedVehicles,
				vehicleCount: vehicles.length,
				maxVehicles,
				userType: user?.userType === "company" ? "Empresa" : "Persona",
			};

			const content = TemplateEngine.render(vehiclesTemplate, data);
			document.getElementById("app").innerHTML = await Navbar.render() + content;

			// Assign event listener after rendering the DOM
			const container = document.getElementById("vehiclesContainer");
			if (container) {
				container.addEventListener("click", (event) => {
					const button = event.target.closest("button");
					if (!button) return;

					const vehicleId = button.dataset.vehicleId;
					const action = button.dataset.action;

					switch (action) {
						case "view":
							VehiclesController.viewVehicle(vehicleId);
							break;
						case "edit":
							VehiclesController.editVehicle(vehicleId);
							break;
						case "addService":
							VehiclesController.addService(vehicleId);
							break;
						case "pics":
							VehiclesController.viewPics(vehicleId);
							break;
						default:
							console.warn("No action defined for", action);
					}
				});
			}

			// Assign event listener to the 'Agregar Vehículo' button
			const addVehicleButton = document.querySelector(".addvehicle");
			if (addVehicleButton) {
				addVehicleButton.addEventListener("click", async (e) => {
					e.preventDefault();
					await VehiclesController.showAddVehicleModal();
				});
			}




		} catch (error) {
			console.error("Error loading vehicles:", error);
			document.getElementById("app").innerHTML =
				Navbar.render() +
				`
				<div class="container mt-4">
					<div class="alert alert-danger">Error al cargar los vehículos</div>
				</div>
			`;
		}
	},

	showAddVehicleModal: async () => {
		const user = AuthService.getCurrentUser();
		const vehiclesContador = await ApiService.post("apiapp/ObtenerVehiculosContador", null, user?.token);


		const maxVehicles =
			user?.userType === "company" ? AppConfig.limits.maxVehiclesCompany : AppConfig.limits.maxVehiclesPerson;

		if (vehiclesContador.vehiculos >= maxVehicles) {
			await Swal.fire({
				title: "Límite alcanzado",
				text: `Has alcanzado el límite de ${maxVehicles} vehículos para tu tipo de cuenta.`,
				icon: "warning",
			});
			return;
		}


		const data = {
			maxYear: new Date().getFullYear(),
			minYear: new Date().getFullYear() - 40,
		};

		const popHtml = TemplateEngine.render(addVehicleModalTemplate, data);


		const result = await Swal.fire({
			title: "Agregar Vehículo",
			html: popHtml,
			width: 600,
			showCancelButton: true,
			confirmButtonText: "Agregar",
			cancelButtonText: "Cancelar",
			allowOutsideClick: false,
			didOpen: async () => {
				await new Promise(r => setTimeout(r, 0));

				// solo colores y compañías
				await VehiclesController.loadSimpleselects();
				const popup = Swal.getPopup();
				await VehicleSelectModule.mount({
					root: popup,
					selectMarca: "#selectMarca",
					selectModelo: "#selectModelo",
					selectVehiculo: "#selectVehiculo",
				});
				const fechaInput = document.getElementById('inputFechaAdquisicion');
				if (fechaInput) {
					fechaInput.max = new Date().toISOString().slice(0, 7);
					const anioInput = document.getElementById('inputAnio');
					if (anioInput) {
						anioInput.addEventListener('input', () => {
							if (anioInput.value) fechaInput.min = anioInput.value + '-01';
						});
					}
				}
			},
			preConfirm: () => {
				const form = document.getElementById("addVehicleForm");
				const formData = new FormData(form);
				return Object.fromEntries(formData);
			},
		});
		if (result.isConfirmed && result.value) {
			await VehiclesController.saveVehicle(result.value);
		}
	},

	// idVehiculoReal: solo en edición (el backend distingue alta/edición con él).
	saveVehicle: async (vehicleData, idVehiculoReal = null) => {
		if (vehicleData.fechaAdquisicion) {
			vehicleData.fechaAdquisicion = vehicleData.fechaAdquisicion + '-01';
		}
		// El backend (CrearVehiculoDTO) espera "titular"; con "esTitular" quedaba siempre en false.
		vehicleData.titular = vehicleData.esTitular === "true";
		delete vehicleData.esTitular;
		if (idVehiculoReal) vehicleData.idVehiculoReal = idVehiculoReal;
		try {
			const user = AuthService.getCurrentUser();
			const resp = await ApiService.post("apiapp/CrearEditarVehiculo", vehicleData, user?.token);
			if (!(resp?.status >= 1)) {
				Swal.fire("Error", resp?.message || "No se pudo guardar el vehículo", "error");
				return;
			}
			Swal.fire("Éxito", "Vehículo guardado correctamente", "success");
			VehiclesController.render();
		} catch (error) {
			Swal.fire("Error", "No se pudo guardar el vehículo", "error");
			//console.error("Error saving vehicle:", error);
		}
	},

	viewPics: async (dominio) => {
		try {
			const user = AuthService.getCurrentUser();
			const response = await ApiService.post(`apiapp/ObtenerFotosVehiculo`, { dominio }, user?.token);
			const photos = response?.fotos || [];

			const photoGallery = photos.map(photo => `
				<div class="swiper-slide">
					<img src="${photo.Url}" alt="Foto del vehículo" class="photo-thumbnail" style="max-width:300px; max-height:220px;" />
					<button class="btn btn-danger delete-photo" data-photo-id="${photo.Id}">
						<i class="fas fa-trash-alt"></i>
					</button>
				</div>
			`).join("");

			const modalContent = `
				<div class="mb-4">
					<span>Dominio: ${dominio}</span> 
					<span class="ms-2">Fotos: ${photos.length}</span>
					<a href="#" class="ms-4" id="addPhotoLink" style="color:green;">
						<i class="fas fa-plus"></i> 
						<i class="fa-solid fa-images"></i>
					</a>
				</div>
				<div class="swiper-container" style="height: 250px; overflow: hidden;">
					<div class="swiper-wrapper">
						${photoGallery}
					</div>
					<div class="swiper-button-next"></div>
					<div class="swiper-button-prev"></div>
					<div class="swiper-pagination"></div>
				</div>
				<input type="file" id="uploadPhotoInput" accept="image/*" style="display:none;" />
			`;

			Swal.fire({
				title: "Álbum de Fotos",
				html: modalContent,
				width: 800,
				showCancelButton: true,
				confirmButtonText: "Cerrar",
				didOpen: () => {
					// Ensure Swiper is initialized after DOM is fully rendered
					setTimeout(() => {
						const swiper = new Swiper('.swiper-container', {
							modules: [Navigation, Pagination],
							navigation: {
								nextEl: '.swiper-button-next',
								prevEl: '.swiper-button-prev',
							},
							pagination: {
								el: '.swiper-pagination',
								clickable: true,
							},
							loop: true, // Ensure looping for better navigation
						});
					}, 0);

					// Add event listener for deleting photos
					document.querySelectorAll(".delete-photo").forEach(button => {
						button.addEventListener("click", async (e) => {
							const photoId = e.target.dataset.photoId;
							const formData = new FormData();
							formData.append("dominio", dominio);
							formData.append("photoId", photoId);

							Swal.fire({
								title: "Eliminando...",
								allowOutsideClick: false,
								didOpen: () => {
									Swal.showLoading();
								}
							});

							await ApiService.post(`apiapp/EliminarFotoVehiculo`, formData, user?.token);

							Swal.close();
							Swal.fire("Éxito", "Foto eliminada correctamente", "success");
							VehiclesController.viewPics(dominio); // Refresh the modal
						});
					});

					document.getElementById("addPhotoLink").addEventListener("click", async (e) => {
						e.preventDefault();
						document.getElementById("uploadPhotoInput").click();
					});

					// Add event listener for uploading photos
					document.getElementById("uploadPhotoInput").addEventListener("change", async () => {
						const fileInput = document.getElementById("uploadPhotoInput");
						const file = fileInput.files[0];
						if (!file) {
							Swal.fire("Error", "Por favor selecciona una foto para subir", "error");
							return;
						}

						const processed = await ImageProcessor.process(file, {
							quality: 0.6,
							maxWidth: 800,
							maxHeight: 800
						});

						const formData = new FormData();
						formData.append("dominio", dominio);
						formData.append("file", processed);
						Swal.fire({
							title: "Subiendo...",
							allowOutsideClick: false,
							didOpen: () => {
								Swal.showLoading();
							}
						});

						await ApiService.post(`apiapp/SubirFotoVehiculo`, formData, user?.token, {
							headers: { "Content-Type": "multipart/form-data" }
						});

						Swal.close();
						Swal.fire("Éxito", "Foto subida correctamente", "success");
						VehiclesController.viewPics(dominio); // Refresh the modal
					});
				}
			});
		} catch (error) {
			console.error("Error loading photos:", error);
			Swal.fire("Error", "No se pudieron cargar las fotos del vehículo", "error");
		}
	},


	viewVehicle: async (vehicleId) => {
		const user = AuthService.getCurrentUser();
		const objvehicle = await ApiService.post("apiapp/ObtenerVehiculoDominio", { dominio: vehicleId }, user?.token);
		const vehicle = objvehicle?.vehiculo;
		if (!vehicle) {
			Swal.fire({
				title: "Error en vehículo",
				text: `No se pudieron obtener datos del vehículo.`,
				icon: "warning",
			});
			return;
		}
		const modalContent = TemplateEngine.render(addVehicleModalTemplate, {});
		Swal.fire({
			title: "Ver Vehículo",
			html: modalContent,
			width: 600,
			showCancelButton: false,
			confirmButtonText: "Cerrar",
			allowOutsideClick: false,
			didOpen: async () => {
				await new Promise(r => setTimeout(r, 0));
				await VehiclesController.loadSimpleselects();

				const popup = Swal.getPopup();
				await VehicleSelectModule.mount({
					root: popup,
					selectMarca: "#selectMarca",
					selectModelo: "#selectModelo",
					selectVehiculo: "#selectVehiculo",
					initial: {
						marcaId: vehicle.IdMarca,
						modeloId: vehicle.IdModelo,
						vehiculoId: vehicle.IdVehiculo,
					},
				});
				document.getElementById("inputAnio").value = vehicle.Anio;
				document.getElementById("inputDominio").value = vehicle.Dominio;
				document.getElementById("selectColor").value = vehicle.IdColor;
				document.querySelector("[name=cedula]").value = vehicle.Cedula;
				document.getElementById("inputKilometraje").value = vehicle.Kilometraje;
				document.querySelector("[name=kmMensuales]").value = vehicle.KmMensuales;
				document.getElementById("inputChasis").value = vehicle.Chasis;
				document.getElementById("inputMotor").value = vehicle.Motor;
				document.getElementById("selectCompania").value = vehicle.IdCompania;
				document.querySelector("[name=poliza]").value = vehicle.Poliza;
				document.querySelector("[name=cobertura]").value = vehicle.Cobertura;
				document.querySelector("[name=esTitular]").value = vehicle.EsTitular;
				const fechaInputV = document.getElementById('inputFechaAdquisicion');
				if (fechaInputV) {
					fechaInputV.max = new Date().toISOString().slice(0, 7);
					if (vehicle.FechaAdquisicion) fechaInputV.value = vehicle.FechaAdquisicion.slice(0, 7);
					if (vehicle.Anio) fechaInputV.min = vehicle.Anio + '-01';
				}
				document.querySelector("#btnCedula").addEventListener("click", async (e) => {
					e.preventDefault();
					Swal.close();
					DocumentViewer.openDocumentacionVehiculo(vehicle.Dominio, vehicle.Documentacion, VehiclesController.render);
				});

				document.querySelector("#btnSeguro").addEventListener("click", async (e) => {
					e.preventDefault();
					Swal.close();
					DocumentViewer.openSeguroVehiculo(vehicle.Dominio, vehicle.Documentacion, VehiclesController.render);
				});

				const form = document.getElementById("addVehicleForm");
				form.querySelectorAll('input, textarea').forEach(e => e.readOnly = true);
				form.querySelectorAll('select, input[type="file"]').forEach(e => e.disabled = true);
			},
		});
	},

	editVehicle: async (vehicleId) => {
		const user = AuthService.getCurrentUser();
		const objvehicle = await ApiService.post("apiapp/ObtenerVehiculoDominio", { dominio: vehicleId }, user?.token);
		const vehicle = objvehicle?.vehiculo;
		if (!vehicle) {
			Swal.fire({
				title: "Error en vehículo",
				text: `No se pudieron obtener datos del vehículo.`,
				icon: "warning",
			});
			return;
		}
		// Render modal with vehicle data
		const modalContent = TemplateEngine.render(addVehicleModalTemplate, {});
		Swal.fire({
			title: "Editar Vehículo",
			html: modalContent,
			width: 600,
			showCancelButton: true,
			confirmButtonText: "Guardar",
			cancelButtonText: "Cancelar",
			allowOutsideClick: false,
			didOpen: async () => {
				await new Promise(r => setTimeout(r, 0));
				await VehiclesController.loadSimpleselects();
				const popup = Swal.getPopup();
				await VehicleSelectModule.mount({
					root: popup,
					selectMarca: "#selectMarca",
					selectModelo: "#selectModelo",
					selectVehiculo: "#selectVehiculo",
					initial: {
						marcaId: vehicle.IdMarca,
						modeloId: vehicle.IdModelo,
						vehiculoId: vehicle.IdVehiculo,
					},
				});
				document.getElementById("inputAnio").value = vehicle.Anio;
				const inputDominio = document.getElementById("inputDominio");
				inputDominio.value = vehicle.Dominio;
				inputDominio.readOnly = true; // el backend rechaza cambiar el dominio al editar
				document.getElementById("selectColor").value = vehicle.IdColor;
				document.querySelector("[name=cedula]").value = vehicle.Cedula;
				document.getElementById("inputKilometraje").value = vehicle.Kilometraje;
				document.querySelector("[name=kmMensuales]").value = vehicle.KmMensuales;
				document.getElementById("inputChasis").value = vehicle.Chasis;
				document.getElementById("inputMotor").value = vehicle.Motor;
				document.getElementById("selectCompania").value = vehicle.IdCompania;
				document.querySelector("[name=poliza]").value = vehicle.Poliza;
				document.querySelector("[name=cobertura]").value = vehicle.Cobertura;
				document.querySelector("[name=esTitular]").value = vehicle.EsTitular;
				const fechaInputE = document.getElementById('inputFechaAdquisicion');
				if (fechaInputE) {
					fechaInputE.max = new Date().toISOString().slice(0, 7);
					if (vehicle.FechaAdquisicion) fechaInputE.value = vehicle.FechaAdquisicion.slice(0, 7);
					if (vehicle.Anio) fechaInputE.min = vehicle.Anio + '-01';
					const anioInputE = document.getElementById('inputAnio');
					if (anioInputE) {
						anioInputE.addEventListener('input', () => {
							if (anioInputE.value) fechaInputE.min = anioInputE.value + '-01';
						});
					}
				}
				document.querySelector("#btnCedula").addEventListener("click", async (e) => {
					e.preventDefault();
					Swal.close();
					DocumentViewer.openDocumentacionVehiculo(vehicle.Dominio, vehicle.Documentacion, VehiclesController.render);
				});
				document.querySelector("#btnSeguro").addEventListener("click", async (e) => {
					e.preventDefault();
					Swal.close();
					DocumentViewer.openSeguroVehiculo(vehicle.Dominio, vehicle.Documentacion, VehiclesController.render);
				});
			},
			preConfirm: () => {
				const form = document.getElementById("addVehicleForm");
				const formData = new FormData(form);
				const vehicleData = Object.fromEntries(formData);

				const maxYear = new Date().getFullYear();
				const minYear = maxYear - 40;
				const anioVehiculo = parseInt(vehicleData.anio, 10);

				if (isNaN(anioVehiculo) || anioVehiculo < minYear || anioVehiculo > maxYear) {
					Swal.showValidationMessage(
						`El año del vehículo debe estar entre ${minYear} y ${maxYear}`
					);
					return false;
				}

				if (vehicleData.dominio.length !== 6 && vehicleData.dominio.length !== 7) {
					Swal.showValidationMessage("El dominio parece incorrecto");
					return false;
				}

				if (vehicleData.chasis.length < 6) {
					Swal.showValidationMessage("El número de chasis parece incorrecto");
					return false;
				}

				if (vehicleData.motor.length < 6) {
					Swal.showValidationMessage("El número de motor parece incorrecto");
					return false;
				}

				if (vehicleData.cedula.length < 6) {
					Swal.showValidationMessage("La cédula parece incorrecta");
					return false;
				}

				const fechaAdq = vehicleData.fechaAdquisicion;
				if (fechaAdq && vehicleData.anio) {
					const anioFecha = parseInt(fechaAdq.split('-')[0], 10);
					if (anioFecha < parseInt(vehicleData.anio, 10)) {
						Swal.showValidationMessage("La fecha de adquisición no puede ser anterior al año del vehículo");
						return false;
					}
				}

				return vehicleData; // ✅ si pasa validación, recién ahí cierra y devuelve datos
			},
		}).then((result) => {
			if (result.isConfirmed) {
				VehiclesController.saveVehicle(result.value, vehicle.IdVehiculoReal);
			}
		});
	},

	addService: (vehicleId) => {
		localStorage.setItem("ServiceToVehicle", vehicleId);
		window.location.hash = "services";
	},

	loadInitialData: async () => {
		try {

			await VehiclesController.loadSimpleselects();

		} catch (error) {
			console.error("Error loading initial data:", error);
		}
	},

	loadSimpleselects: async () => {
		try {
			// Cargar colores
			const colores = await VehiclesController.loadColores();
			VehiclesController.populateSelect("selectColor", colores);

			// Cargar compañías de seguro
			const companias = await VehiclesController.loadCompanias();
			VehiclesController.populateSelect("selectCompania", companias);

		} catch (error) {
			console.error("Error loading initial data:", error);
		}
	},

	populateSelect: (selectId, options) => {
		const select = document.getElementById(selectId);
		// Limpiar opciones existentes (excepto la primera)
		while (select.children.length > 1) {
			select.removeChild(select.lastChild);
		}

		options.forEach((option) => {
			const optionElement = document.createElement("option");
			optionElement.value = option.id;
			optionElement.textContent = option.name;
			select.appendChild(optionElement);
		});
	},


	loadColores: async () => {
		const response = await ApiService.post("colores/obtener/");
		if (response.status == 0) {
			const transformada = response.message.map(item => ({
				id: item.id,
				name: item.nombre
			}));
			return transformada;
		}
	},

	loadCompanias: async () => {
		const response = await ApiService.post("API_Companias/obtener/");
		if (response.status == 0) {
			const transformada = response.result.map(item => ({
				id: item.Id,
				name: item.RazonSocial
			}));
			return transformada;
		}
	},

};
